import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link, useParams } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa";
import { Editor } from "@tinymce/tinymce-react";
import Swal from "sweetalert2";
import axios from "axios";
import Switch from "react-switch";
import Select from "react-select";
import { getAdvisoryDetails } from "../../../../redux/actions/campaignActions";
import ImgChangeIcon from "../../../../assets/images/camera-icon.png";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../new/new.scss";

const Editadvisory = () => {
  const [file, setFile] = useState({
    files: "",
    preview:
      "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg",
  });
  const [profile_pic_name, setProfile_pic_name] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [countryId, setCountryID] = useState([]);
  const [description, setDescription] = useState("");
  const [checked, setChecked] = useState(false);
  const id = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const advisoryView = useSelector((state) => state.advisoryView);
  const { advisory } = advisoryView;

  let token = localStorage.getItem("accessToken");

  const handleChange = (checked) => {
    setChecked(checked);
  };

  useEffect(() => {
    dispatch(getAdvisoryDetails(token, id));
  }, [dispatch]);

  useEffect(() => {
    if (advisory?.data?.profile_pic !== null) {
      setFile({
        files: advisory?.data?.profile_pic,
        preview: advisory?.data?.profile_pic,
      });
    } else {
      setFile({
        files: "",
        preview:
          "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg",
      });
    }
  }, [advisory]);

  useEffect(() => {
    if (advisoryView) {
      if (advisoryView?.loading !== undefined) {
        setLoading(advisoryView?.loading);
      }
    }
  }, [advisoryView]);

  useEffect(() => {
    if (advisory) {
      setValue("firstname", advisory?.data?.firstname);
      setValue("lastname", advisory?.data?.lastname);
      setValue("email", advisory?.data?.email);
      setValue("profile_designation", advisory?.data?.profile_designation);
      setValue("email", advisory?.data?.email);
      setValue("website_url", advisory?.data?.website_url);
      setValue("youTube_url", advisory?.data?.youTube_url);
      setValue("linkedIn_url", advisory?.data?.linkedIn_url);
      setValue("twitter_url", advisory?.data?.twitter_url);
      setProfile_pic_name(advisory?.data?.profile_pic);
      setCountryID(advisory?.data?.country_id);
      setDescription(advisory?.data?.about_profile);
      setChecked(advisory?.data?.status == 1 ? true : false);
    }
  }, [advisory]);

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const profileImage = async (e) => {
    const baseUrl = process.env.REACT_APP_API + "admin/update-userprofilepic";
    const selected = e.target.files[0];
    const ALLOWED_TYPES = ["image/png", "image/jpeg", "image/jpg"];
    if (selected && ALLOWED_TYPES.includes(selected.type)) {
      let formData = new FormData();
      setLoading(true);
      formData.append("user_id", id.advosoryId);
      formData.append("file", selected);
      let axiosConfig = {
        headers: {
          "Content-Type": "multipart/form-data",
          "x-access-token": token,
        },
      };
      const res = await axios
        .patch(baseUrl, formData, axiosConfig)
        .then((response) => {
          setFile({
            files: response?.data?.data?.document_name,
            preview: response?.data?.data?.document_name,
          });
          setLoading(false);
          setError(false);
        });
    } else {
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    // axios
    //   .get(process.env.REACT_APP_API + "get-country")
    //   .then((res) => setData(res.data.data))
    //   .catch((err) => console.log(err));
    getCountry();
  }, []);

  // const countries = [...new Set(data)];
  // countries.sort();

  const getCountry = async () => {
    const res = await axios({
      method: "GET",
      url: process.env.REACT_APP_API + "get-country",
    });

    const data = res?.data?.data;
    const options = data?.map((d) => ({
      value: d?.id,
      label: d?.country_name,
    }));
    setData(options);
  };

  const handleCountry = (e) => {
    // const getCounryId = e.target.value;
    // setCountryID(getCounryId);
    setCountryID(Array.isArray(e) ? e.map((x) => x.value) : []);
  };

  const onSubmit = async (data) => {
    setLoading(true);
    let formData = new FormData();

    formData.append("id", id.advosoryId);
    formData.append("firstname", data?.firstname);
    formData.append("lastname", data?.lastname);
    formData.append("email", data?.email);
    formData.append("profile_designation", data?.profile_designation);
    formData.append("website_url", data?.website_url);
    formData.append("twitter_url", data?.twitter_url);
    formData.append("linkedIn_url", data?.linkedIn_url);
    formData.append("youTube_url", data?.youTube_url);
    formData.append("profile_pic", file?.files);
    formData.append("profile_pic_name", profile_pic_name);
    formData.append("country_id", JSON.stringify(countryId));
    formData.append("about_profile", description);
    formData.append("status", checked === true ? 1 : 0);
    try {
      const res = await axios({
        method: "PATCH",
        url: process.env.REACT_APP_API + "update-our-advisory",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-access-token": token,
        },
      });

      if (res.data.status === 200) {
        setLoading(false);
        Swal.fire({
          title: "Success",
          timer: 2500,
          timerProgressBar: true,
          text: res.data.message,
          icon: "success",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
        navigate("/advisory-board");
      }
    } catch (error) {
      if (error.response !== "" && error.response.data.message !== "") {
        setLoading(false);
        Swal.fire({
          title: "Error",
          timer: 2500,
          timerProgressBar: true,
          text: error.response.data.message,
          icon: "error",
          confirmButtonColor: "#f27474",
          confirmButtonText: "OK",
          dangerMode: true,
          showCloseButton: true,
        });
      }
    }
  };

  return (
    <div className="new">
      <Loader isLoading={loading} />
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <span className="backarrow">
            <FaAngleLeft onClick={() => navigate(-1)} />
          </span>
          <h1 className="view-page-tittle">Edit Advisory Team</h1>
        </div>

        <div className="bottom">
          <div className="left">
            <div className="profile-pic-div">
              <div className="imgChange-div">
                <img src={ImgChangeIcon} alt="" className="imgChangeIcon" />
              </div>
              <input
                type="file"
                name="file"
                accept="image/png , image/jpeg"
                title=""
                className="profile-pic-select"
                onChange={(e) => profileImage(e)}
              />

              <img
                src={file ? file.preview : advisory?.data?.profile_pic}
                alt=""
                className="setting-profile"
              />
            </div>

            {error && (
              <span style={{ color: "red" }}>
                Please upload file in jpg,jpeg and png format
              </span>
            )}
          </div>
          <div className="right">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="formInput">
                <label>First Name</label>
                <input
                  type="text"
                  name="firstname"
                  {...register("firstname", {
                    required: "First name is required",
                    pattern: {
                      value: /^[a-zA-Z_ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter First Name"
                />
                {errors.firstname && (
                  <div className="invalid-feedback">
                    {errors.firstname.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Last Name</label>
                <input
                  type="text"
                  name="lastname"
                  {...register("lastname", {
                    required: "Last name is required",
                    pattern: {
                      value: /^[a-zA-Z_ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Last Name"
                />
                {errors.lastname && (
                  <div className="invalid-feedback">
                    {errors.lastname.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value:
                        /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                      message: "Please enter a valid email address",
                    },
                  })}
                  placeholder="Enter Email"
                />
                {errors.email && (
                  <div className="invalid-feedback">{errors.email.message}</div>
                )}
              </div>
              <div className="formInput">
                <label>Profession</label>
                <select
                  name="profile_designation"
                  {...register("profile_designation", {
                    required: "Profession is required",
                  })}
                >
                  <option value="" disabled selected hidden>
                    Select Profession
                  </option>
                  <option value="accountants">Accountants</option>
                  <option value="lawyers">Lawyers</option>
                  <option value="consulting Company">Consulting company</option>
                </select>
                {errors.profile_designation && (
                  <div className="invalid-feedback">
                    {errors.profile_designation.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Country</label>
                {/* <select
                  name="countryPartner"
                  className="sort-by dropdown"
                  onChange={(e) => handleCountry(e)}
                  value={countryId}
                >
                  <option value="" disabled selected hidden>
                    Select Country
                  </option>
                  {countries.map((items) => (
                    <option key={items.id} value={items.id}>
                      {items.country_name}
                    </option>
                  ))}
                </select> */}
                <Select
                  className="sort-by dropdown"
                  isMulti={true}
                  options={data}
                  value={countryId?.map(
                    (id) => data?.filter((d) => d.value == id)[0]
                  )}
                  onChange={handleCountry}
                />
              </div>
              <div className="formInput">
                <label>Website</label>
                <input
                  type="text"
                  name="website_url"
                  {...register("website_url", {
                    pattern: {
                      value:
                        /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/g,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Website"
                />
                {errors.website_url && (
                  <div className="invalid-feedback">
                    {errors.website_url.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Twitter</label>
                <input
                  type="text"
                  name="twitter_url"
                  {...register("twitter_url", {
                    pattern: {
                      value:
                        /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/g,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Twitter"
                />
                {errors.twitter_url && (
                  <div className="invalid-feedback">
                    {errors.twitter_url.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Linkedin</label>
                <input
                  type="text"
                  name="linkedIn_url"
                  {...register("linkedIn_url", {
                    pattern: {
                      value:
                        /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/g,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Linkedin"
                />
                {errors.linkedIn_url && (
                  <div className="invalid-feedback">
                    {errors.linkedIn_url.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Youtube</label>
                <input
                  type="text"
                  name="youTube_url"
                  {...register("youTube_url", {
                    pattern: {
                      value:
                        /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/g,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Youtube"
                />
                {errors.youTube_url && (
                  <div className="invalid-feedback">
                    {errors.youTube_url.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Status</label>
                <Switch
                  onChange={handleChange}
                  checked={checked == 1 ? true : false}
                />
              </div>
              <div className="formInputDescription">
                <label>Description</label>
                <Editor
                  initialValue={description}
                  apiKey="4xerbueqmh9h3gt7gkvu7xnlqgntlyv3qlqtcx6kr7du2cl2"
                  init={{
                    selector: "textarea",
                    height: 300,
                    menubar: true,
                    toolbar: "bottom",
                    plugins: [
                      "advlist autolink lists link image charmap print preview anchor",
                      "searchreplace visualblocks code fullscreen",
                      "insertdatetime media table paste code help wordcount",
                      "lists",
                    ],
                    toolbar:
                      "undo redo | formatselect | " +
                      "bold italic backcolor | alignleft aligncenter " +
                      "alignright alignjustify | bullist numlist outdent indent | " +
                      "removeformat | help",
                    content_style:
                      "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                  }}
                  onEditorChange={(newText) => setDescription(newText)}
                />
              </div>

              <button className="submitBtn">Save</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Editadvisory;
